import { ArgumentError } from '../utils/errors';
import { BaseAPIModel } from '@weezevent/weezjs-core';

export default class SeatInventory extends BaseAPIModel {
    fields() {
        return {
            uuid: { primaryKey: true }
        };
    }

    static listUrl({ organizationId, chartId, zoneId, inventoryId }) {
        if (!organizationId || !chartId || !zoneId || !inventoryId) {
            throw new ArgumentError('[Model][SeatInventory][get] organizationId, chartId, zoneId and inventoryId, are mandatory');
        }

        return `/ticket/organizations/${organizationId}/charts/${chartId}/inventories/${inventoryId}/seats?zones=${zoneId}`;
    }
}
